import { Component, ElementRef, Injector, ViewChild } from '@angular/core';

import { ProductType } from '@core/model/enums';

import { WebElementRefInstanceType } from '@model/web-element-ref-instance.type';
import { RefinanceBaseComponent } from '../refinance-base';

@Component({
  selector: 'app-refinance-rapiflex',
  templateUrl: './refinance-rapiflex.component.html',
})
export class RefinanceRapiflexComponent extends RefinanceBaseComponent {
  @ViewChild('refinanceRapiflexRef') public refinanceRapiflexRef: ElementRef;
  public refinanceRapiflexRefInstance: WebElementRefInstanceType;

  protected get webElementRef(): ElementRef {
    return this.refinanceRapiflexRef;
  }

  protected set webElementRefInstance(instance: WebElementRefInstanceType) {
    this.refinanceRapiflexRefInstance = instance;
  }

  protected get productType(): ProductType {
    return ProductType.RETRF;
  }

  constructor(injector: Injector) {
    super(injector);
  }
}
